import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getProjectMembersByProjectId } from "../../api/projectApi";

export const fetchBusinessMembers = createAsyncThunk(
  "businessMembers/fetchBusinessMembers",
  async (_, thunkAPI) => {
    const acctId = Number(localStorage.getItem("user_id"));
    const userName = localStorage.getItem("user_email");
    const projectUuid = localStorage.getItem("project_uuid");
    // 沒有 projectId，直接回安全結構
    if (!projectUuid) {
      return {
        members: [],
        isBusinessManager: false,
        isEdcAdmin: false,
        authorityCodes: [],
      };
    }

    try {
      const res = await getProjectMembersByProjectId(userName, projectUuid);
      const data = res.data;

      if (!data.success) {
        return {
          members: [],
          isBusinessManager: false,
          isEdcAdmin: false,
          authorityCodes: [],
        };
      }

      const members = data.members || [];
      const currentMember = members.find(m => m.acct_no === acctId);

      let isBusinessManager = false;
      let isEdcAdmin = false;
      let authorityCodes = [];

      if (currentMember?.member_role_list) {
        authorityCodes = currentMember.member_role_list.flatMap(
          r => r.authority_code || []
        );
        isBusinessManager = currentMember.member_role_list.some(
          r => r.role_name === "Business Process Manager"
        );
        isEdcAdmin = currentMember.member_role_list.some(
          r => r.role_name === "eDC Admin"
        );
      }
      return { members, isBusinessManager, isEdcAdmin, authorityCodes };

    } catch (error) {
      if (error.response?.status === 401) {
        return thunkAPI.fulfillWithValue({
          members: [],
          isBusinessManager: false,
          isEdcAdmin: false,
          authorityCodes: [],
        });
      }
      return thunkAPI.rejectWithValue("發生錯誤，請稍後再試");
    }
  }
);

const businessSlice = createSlice({
  name: "businessMembers",
  initialState: {
    members: [],
    isBusinessManager: false,
    isEdcAdmin: false,
    authorityCodes: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearBusinessMembers(state) {
      state.members = [];
      state.isBusinessManager = false;
      state.isEdcAdmin = false;
      state.authorityCodes = [];
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessMembers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBusinessMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.members = action.payload.members;
        state.isBusinessManager = action.payload.isBusinessManager;
        state.isEdcAdmin = action.payload.isEdcAdmin;
        state.authorityCodes = action.payload.authorityCodes;
      })
      .addCase(fetchBusinessMembers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearBusinessMembers } = businessSlice.actions;
export default businessSlice.reducer;
